export default __webpack_public_path__ + "static/media/colorSplotchBronze.94fe819e.svg";